import gql from 'graphql-tag';

export const GET_OFFER_AFFILIATES_QUERY = gql`
  query GetOfferAffiliates(
    $offerId: Int!,
    $startDate: DateTime,
    $endDate: DateTime,
    $isLinkOffer: Boolean,
    $isPromoLinkOffer: Boolean
  ) {
    affiliates: offerAffiliates(
      offerId: $offerId,
      startDate: $startDate,
      endDate: $endDate,
      isLinkOffer: $isLinkOffer,
      isPromoLinkOffer: $isPromoLinkOffer
    ) {
      promoAffiliates {
        affiliateId
        affiliateOfferPromoStatus
        affiliateName
        affiliateCode
        affiliateEmail
        affiliateImageUrl
        affiliateOfferPromoId
        offerAutomationConfigId
        aspirexMemberId
        avgSale
        avgSaleBase
        codeCreatedDate
        codeStatus
        conversions
        payoutEarned
        payoutEarnedBase
        payoutMade
        sales
        salesBase
        offerPayoutId
        endDate
        externalDiscountCode
        externalDiscountCodeGId
        deletedDate
        providerMetadata
        baseCurrencies
        startDate
      }
      linkAffiliatesStats {
        affiliateEmail
        affiliateId
        affiliateOfferId
        affiliateImageUrl
        affiliateLink
        affiliateShortLink
        affiliateName
        affiliateOfferId
        aspirexMemberId
        avgSale
        clicks
        conversionRatio
        conversions
        linkCreationDate
        linkStatus
        payoutEarned
        payoutMade
        sales
        nonDuplicateConversions
        salesBase
        avgSaleBase
        payoutEarnedBase
      }
      linkAffiliates {
        affiliateId
        offerPayoutId
        offerAutomationConfigId
        status
        affiliateDeeplinks {
          id,
          affiliateDeepLinkUrl,
          url,
          label,
          createdDate
          deletedDate,
          shortLink
        }
        affiliate {
          email
          memberId
          name
          profilePicture
          status
          deletedDate
        }
        id
        deletedDate
        createdDate
        updateLog
        deeplinkUrl
        affiliateShortLink
      }
    }
  }
`;
